import { TaxiIcon } from './TaxiIcon';

/**
 * author: Google
 * id 32F3835A-EBD0-4927-9497-6F67F7075EAF
 * name taxi
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/taxi.svg
 * tags
 * - Transportation + Road 
 * - Navigation 
 */
export const LocalTaxiIcon = TaxiIcon;
export default LocalTaxiIcon